export default __webpack_public_path__ + "static/media/27-LazySummer.fe44b294.jpeg";